module.exports = new __parcel__URL__("spelling.438ff714.gif").toString();